export const response_alert = {
  INFORMATION_ALERT_WITHOUT_ACTION: 1,
  ALERT_WITH_ACTION: 2,
  ALERT_WITHOUT_ACTION: 3,
  CONNECTION_ERROR: 4,
  CONTACT_SUPPORT: 5,
};

export const user_status = {
  ACTIVE: "1",
  NOT_ACTIVE: "2",
  MODERATION: "3",
  REFUSAL_TO_REGISTRATION: "4",
  BAN: "5",
  IN_REGISTRATION_PROCESS: "6",
};

export const policy_status = {
  ACTIVE: "1",
  EXPIRED: "2",
  BALANCE_INSUFFICIENT: "3",
  BENEFITS_UPDATING: "4",
  BENEFITS_CHECK_FROM_LOCAL: "1",
  CLAIM_NOT_ALLOWED: "5",
};

export const POStatus = {
  POC000: "payment Failed", // PO Created but payment Failed
  POC001: "payment pending", // PO Created but
  POC002: "vendor invoice", // Waiting for
  POC003: "E-Invoice", // E-Invoice not generated
  POC004: "Dispatched", // Pending Delivery
  POC005: "Out for delivery", // Out for delivery
  POC006: "Delivered", // Delivered
  POC007: "Completed", // Completed
};

export const newPoEnum = {
  POC000: "Payment Failed",
  POC001: "Payment Pending",
  POC002: "PI Not Received",
  POC003: "Pending Delivery",
  POC004: "Delivered",
  POC005: "eInvoice Sent",
  POC006: "Completed",
  POC007: "Cancelled",
  POC008: "Invoice Failed",
};

// B2B PO status flow — distinct from the regular (non-B2B) PO flow above.
// Mirrors the backend's `PO_STATUS_LABELS` (KAN-516) exactly — change both
// together, or the UI will label a status with someone else's meaning.
export const newB2BPoEnum = {
  POC000: "Payment Failed",
  POC001: "Order Placed",
  POC002: "Payment Collected",
  POC003: "Delivered",
  POC004: "Out for Delivery",
  POC005: "Invoice Generated",
  POC006: "Invoice Failed",
  POC007: "Vendor Paid",         // Super Admin only
  POC008: "Order Completed",     // Super Admin only
  POC009: "Discrepancy Reported",
  POC010: "Cancelled",
};

// Lifecycle rank, mirrors the backend's `PO_STATUS_ORDER` — the codes are
// NOT in lifecycle order (POC004 comes before POC003), so anything ordering
// B2B PO statuses must sort by this, not by the code string.
export const B2B_PO_STATUS_ORDER = {
  POC001: 10,
  POC000: 20,
  POC002: 30,
  POC004: 40,
  POC009: 50,
  POC003: 60,
  POC006: 70,
  POC005: 80,
  POC007: 90,
  POC008: 100,
  POC010: 110,
};

export const b2bPoStatusList = Object.entries(newPoEnum).map(([code, label]) => ({
  id: code,
  label,
}));
